var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoomPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 19,
    cy: 19,
    r: 8,
    fill: "#7C02BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.03 33.617H4.375V26.96h2v3.253l4.454-4.455 1.415 1.414L7.8 31.616h3.23v2zM26.97 4.383h6.656v6.657h-2V7.787l-4.454 4.455-1.415-1.414L30.2 6.384h-3.23v-2z",
    fill: "#7C02BB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 4,
    fill: "#7C02BB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjQiIGN4PSIxOSIgY3k9IjE5IiByPSI4IiBmaWxsPSIjN0MwMkJCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuMDMwNSAzMy42MTY1TDQuMzczNjEgMzMuNjE2NUw0LjM3MzYxIDI2Ljk1OTdMNi4zNzM2MSAyNi45NTk3TDYuMzc0MzEgMzAuMjEzMUwxMC44Mjg0IDI1Ljc1NzZMMTIuMjQyNiAyNy4xNzE4TDcuNzk5ODQgMzEuNjE2TDExLjAzMDUgMzEuNjE2NUwxMS4wMzA1IDMzLjYxNjVaIiBmaWxsPSIjN0MwMkJCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjYuOTY5NSA0LjM4MzQ5TDMzLjYyNjQgNC4zODM0OUwzMy42MjY0IDExLjA0MDNMMzEuNjI2NCAxMS4wNDAzTDMxLjYyNTcgNy43ODY5NEwyNy4xNzE2IDEyLjI0MjRMMjUuNzU3NCAxMC44MjgyTDMwLjIwMDIgNi4zODQwNEwyNi45Njk1IDYuMzgzNDlMMjYuOTY5NSA0LjM4MzQ5WiIgZmlsbD0iIzdDMDJCQiIvPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSI0IiBmaWxsPSIjN0MwMkJCIi8+Cjwvc3ZnPgo=";
export { SvgIconZoomPurple as ReactComponent };